export class Contact {
  phone?: string;
  email?: string;
  optin?: boolean;
}
